﻿import { store, store$ } from '@redux/store';
import googleAdsEvent from 'features/googleAds';
import LeadFormType from 'features/leadGenerators';
import { selectUiState } from 'layout/redux/selectors';
import { recommendedCommunitiesSubmitted$ } from 'pages/searchResults/redux/observables';
import { distinctUntilKeyChanged, filter, map } from 'rxjs';

const excludeForms = [LeadFormType.InformationFormBasic.toString(), LeadFormType.AskQuestionFormPaid.toString()];

const paidModalSubmission$ = store$.pipe(
  map(selectUiState),
  distinctUntilKeyChanged('isFetchingModal'),
  filter((uiState) => uiState.isFetchingModal),
  map((uiState) => uiState.modalInformation),
  filter((modalInformation) => modalInformation.name === 'leadGenerator'),
  filter((modalInformation) => !excludeForms.includes(modalInformation.leadGeneratorOpener))
);

const trackPaidFormSend = () => store.dispatch(googleAdsEvent({ eventName: 'paidForm' }));

paidModalSubmission$.subscribe(trackPaidFormSend);

const trackRecommendationModalSend = () => store.dispatch(googleAdsEvent({ eventName: 'recommendationModal' }));

recommendedCommunitiesSubmitted$.subscribe(trackRecommendationModalSend);
